module.exports = __webpack_public_path__ + "img/email.7dd49787.png";